import { render, staticRenderFns } from "./FeedTankCorrectionAdd.vue?vue&type=template&id=1db54fb8&"
import script from "./FeedTankCorrectionAdd.vue?vue&type=script&lang=ts&"
export * from "./FeedTankCorrectionAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports